/**
 * A panel that shows a hint that the user can dismiss. We use local storage to
 * keep track of which hints have been dismissed.
 */
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {BannerFlexWrapper, BannerTextWrapper} from '../../Banner';
import {useLocalStorage} from '../useLocalStorage';
import * as S from './CloseableBanner.styles';

interface CloseableBannerProps {
  hintKey: string;
}

export const CloseableBanner: React.FC<CloseableBannerProps> = ({
  hintKey,
  children,
}) => {
  const [isHidden, setIsHidden] = useLocalStorage<boolean>(
    `hint.${hintKey}`,
    false
  );

  const onGotIt = () => {
    setIsHidden(true);
  };
  if (isHidden) {
    return null;
  }

  return (
    <S.BannerWithMargin variant="info">
      <BannerFlexWrapper>
        <Icon name="info" />
        <BannerTextWrapper>{children}</BannerTextWrapper>
      </BannerFlexWrapper>
      <Button variant="ghost" onClick={onGotIt}>
        Dismiss
      </Button>
    </S.BannerWithMargin>
  );
};
